import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormToJsonBlService {

  constructor() { }

  convert(formData): string {
    let jsonString = JSON.stringify(formData, this.jsonFilter);

    // přejmenování všech položek "value" a "label" kvůli deserializaci v controlleru
    // alternativa řešení: https://stackoverflow.com/a/5480605/10932945 (stačilo by takhle řešit položky "value", protože "label" se může přejmenovat i v DTO)
    jsonString = jsonString.replace(/"value":/gi, '"Kod":');
    jsonString = jsonString.replace(/"label":/gi, '"Popis":');

    return jsonString;
  }

  // TODO - toto by se mělo řešit nějak obecněji
  jsonFilter(name, value) {
    // výjimka - pouze číselníkové položky mohou mít v kódovém označení hodnotu 0, jinak se 0 považuje za prázdné pole
    if (name === 'value' && value === 0) {
      return value;
    }

    // filtrování prázdných polí, tzn. těch co mají hodnotu null, "" nebo 0
    // JKo: je to zde kvůli deserializaci na straně serveru. Pokud se to neodfiltruje, neprojde deserializace u primitivních typů, pokud není zadaná hodnota
    // časem toto asi nebude potřeba, pokud budou nastaveny všechny validace ve formuláři...
    if (value !== null && value !== "" && value !== 0) {
      return value;
    };
  }
}
